import { AppComponent }                         from './../app.component';
import { Component, OnInit, Injector }          from '@angular/core';
import User                                     from '../models/User';
import { BaseComponent }                        from '../_components/BaseComponent';
import { BackendService }                       from '../_service/backend.service';

@Component({
  providers       : [ AppComponent ],
  selector        : 'new-app-login',
  templateUrl     : './new-login.component.html',
  styleUrls       : ['./new-login.component.css'],
})

export class NewLoginComponent extends BaseComponent implements OnInit {

  settings        : Object;
  
  user            = new User();
  loading         : boolean = false;
  remember_me     : boolean = false;
  redirect_to     : string = 'dashboard/admin';
  normal_redirect : string = 'dashboard';

  constructor(
              injector : Injector,
              private _backendService   : BackendService,
              private _appCompontent    : AppComponent,
              ) 
  { 
    super(injector);
    this.login = this.login.bind(this);
  }

  ngOnInit() 
  {
   
  }

  softwareSettings() {
        this._backendService.getSoftwareSettings().subscribe(
            data => {
                var localstorage_key = this.project_labels + "_software_settings";
                localStorage.setItem(localstorage_key, JSON.stringify(data));
            },
            err => {
                let error_message = err.message !== undefined ? err.message : err.error;
            },
        );
    }

  isRememberMeAvailable()
  {
    return this.getSettingValue("enable_remember_me") || false ;
  }

    login() 
    {
        this.loading                = true;
        this.errors                 = false;
        this.error_message          = '';
        this.error_detailed_message = '';
        this.error_trace            = '';

        if (this.user.username && this.user.password) 
        {
            this._userService.login({ 'username': this.user.username, 'password': this.user.password , 'remember_me' : this.remember_me })
                .subscribe(
                    data => {
                        if (data['success']) {
                            this._userService.storeUserData(data['success']);
                            if (this._route.snapshot.queryParams['path']) {
                                this.redirect_to = this._route.snapshot.queryParams['path'];
                            } 
                            else if (this._route.url) 
                            {
                                this.redirect_to = this._router.url;
                            }

                            var user_info = JSON.parse(this._localStorageService.getWatchedLocalStorage(this.project_labels + "_user_info"));

                            // Chiediamo nuovamente la sowtware settings per aggiornare eventuali elementi cambiati
                            this.softwareSettings();
                            if (user_info["is_superuser"])
                            {
                                this._router.navigate(['dashboard', 'admin' ]);
                            }
                            else
                            {
                                this._router.navigate([ 'dashboard' ]);
                            }
                            
                            this.loading = false;
                        }
                        if (data['error']) {
                            this.handleErrorFromResponse(data['error']);
                            this.loading = false;
                        }
                    },
                    error => 
                    {
                        if (error['error']) {
                            error = error['error'];
                        }
                        this.handleErrorFromResponse(error);
                        this._interfaceService.openSimpleErrorSnackBar(this.error_trace);
                        this.loading = false;
                    });
        } 
        else 
        {
            this.errors = true;
            this.error_message = this._translateService.instant("generic.login_required");
            this.loading = false;
        }
    }
}
